const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "ok",
            label: t ? t("forms.positive_result") : "Wynnik pozytywny",
            column: 1,
            type: "boolean",
            mandatory: true
        },
        {
            name: "comments",
            label: t ? t("forms.comments") : "Uwagi",
            column: 1,
            type: "textarea",
            mandatory: true
        },
        {
            name: "date",
            label: t ? t("common.date") : "Data",
            column: 1,
            type: "text",
            onlyForReadOnly:true
        },
        {
            name: "user",
            label: t ? t("common.user") : "Użytkownik",
            column: 1,
            type: "text",
            onlyForReadOnly:true,
        },
        {
            name: "accept",
            label: t ? t("forms.approved") : "Zatwierdzono",
            column: 1,
            type: "boolean",
            onlyForReadOnly:true
        },
        {
            name: "acceptDate",
            label: t ? t("forms.approval_date") : "Data zatwierdzenia",
            column: 1,
            type: "text",
            onlyForReadOnly:true,
            conditionalOn: "accept",
            conditionalOnMatchValue: true
        },
        {
            name: "acceptUsername",
            label: t ? t("forms.user_approved") : "Użytkownik zatwierdził",
            column: 1,
            type: "text",
            onlyForReadOnly:true,
            conditionalOn: "accept",
            conditionalOnMatchValue: true
        },
    ]
});

export default fields;
